module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Purple-Monster-With-Bunny-Web-1280.0feb8b8b.jpg";